<div class="creta-mat-column" fxLayout="column">
    <span *ngIf="!items.controls.length && !showPrompter.value" i18n class="extra">Material Type</span>
    <ng-container *ngIf="!items.controls?.length && !showPrompter.value">
        <div fxFlex="grow" fxLayoutAlign="start center" class="pt-1 material-accordion">
            <button mat-button type="button" class="add-mat" (click)="addMaterial()">
                <mat-icon>add_circle</mat-icon>
                <span i18n>Add material type</span>
            </button>
        </div></ng-container
    >

    <div *ngIf="items.controls.length" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="material-type-title" fxLayout="row" fxLayoutAlign="start center">
            <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
            <ng-container *ngIf="!selection.selected.length">
                <mat-icon fontSet="klickdata" fontIcon="kd-icon-document" class="kd-icon-16 no-shadow"></mat-icon>
                <span i18n>Material Items</span>
            </ng-container>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
            <ng-container *ngIf="selectedIndices.length">
                <button
                    class="tools-btn create-material"
                    *ngIf="selectedIndices.length > 1"
                    type="button"
                    (click)="addToLesson()"
                    mat-icon-button
                    matTooltip="Add selected materials to lesson"
                    i18n-matTooltip
                >
                    <mat-icon>play_lesson</mat-icon>
                </button>
                <app-item-translator
                    (onTranslate)="translate({ language_id: $event, indices: selectedIndices })"
                ></app-item-translator>

                <button
                    class="tools-btn create-material"
                    *ngIf="!loadingMaterialsCreation && selectedIndices.length > 1"
                    type="button"
                    (click)="loadingMaterialsCreation = !loadingMaterialsCreation; makeMaterials()"
                    mat-icon-button
                    matTooltip="Split into new materials"
                    i18n-matTooltip
                >
                    <mat-icon>call_split</mat-icon>
                </button>
                <button
                    class="tools-btn"
                    *ngIf="selectedIndices.length > 1"
                    type="button"
                    (click)="merge(selectedIndices)"
                    mat-icon-button
                    matTooltip="Merge into one"
                    i18n-matTooltip
                >
                    <mat-icon>merge_type</mat-icon>
                </button>
                <button
                    class="tools-btn"
                    *ngIf="selectedIndices.length > 1"
                    type="button"
                    (click)="onCreateTestFromMaterial(selectedIndices)"
                    mat-icon-button
                    matTooltip="Create a Quiz from selected items"
                    i18n-matTooltip
                >
                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-test" class="kd-icon-20"></mat-icon>
                </button>
                <button
                    class="tools-btn"
                    type="button"
                    (click)="download()"
                    mat-icon-button
                    matTooltip="Export all selected"
                    i18n-matTooltip
                >
                    <mat-icon>save_alt</mat-icon>
                </button>

                <app-kd-logo-loading *ngIf="loadingMaterialsCreation" size="small"></app-kd-logo-loading>
                <button
                    class="tools-btn"
                    type="button"
                    (click)="delete(selectedIndices)"
                    mat-icon-button
                    matTooltip="Delete multiple items at once"
                    i18n-matTooltip
                >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
                <button
                    class="tools-btn"
                    type="button"
                    (click)="regenerate(selectedIndices)"
                    mat-icon-button
                    matTooltip="Regenerate response for multiple items at once"
                    i18n-matTooltip
                >
                    <mat-icon>autorenew</mat-icon>
                </button>
                <button
                    class="tools-btn"
                    type="button"
                    (click)="copyAll()"
                    mat-icon-button
                    matTooltip="Copy to clipboard"
                    i18n-matTooltip
                >
                    <mat-icon class="material-icons-outlined">copy_all</mat-icon>
                </button></ng-container
            >

            <button
                type="button"
                (click)="onFollowUp(true)"
                class="start-new-prompt"
                mat-icon-button
                matTooltip="Use AI to follow up Material"
                i18n-matTooltip
            >
                <mat-icon>smart_toy</mat-icon>
            </button>
            <button
                *ngIf="items.controls.length"
                mat-icon-button
                type="button"
                class="expand"
                color="primary"
                fxFlex="0 0 auto"
                matTooltip="Open All"
                i18n-matTooltip="@@openAll"
                (click)="expandAll = !expandAll; toggleAll(expandAll)"
            >
                <mat-icon class="expanding" [class.expanded-all]="expandAll">last_page</mat-icon>
            </button>
        </div>
    </div>

    <div class="third-colmn-editor-wrapper mt-1" fxFlex="0 1 100%" fxLayout="column" fxLayoutGap="20px">
        <ng-container *ngIf="items.controls.length">
            <mat-accordion
                formArrayName="resource_items"
                class="third-colmn-editor-wrapper"
                fxFlex="0 1 100%"
                fxLayout="column"
                [multi]="true"
                cdkDropList
                #parentItemsList="cdkDropList"
                [cdkDropListData]="items"
                cdkDropListLockAxis="y"
                (cdkDropListDropped)="drop($event)"
                [cdkDropListConnectedTo]="bundleConnectedList"
            >
                <div
                    class="material-item-wrapper"
                    cdkDrag
                    *ngFor="let item of items.controls; let i = index"
                    cdkDragBoundary=".creta-mat-column"
                    [formGroupName]="i"
                    [id]="'material-item-' + i"
                    [attr.data-item-index]="i"
                    [attr.data-item-type]="item.value.item_type_value"
                    [cdkDragDisabled]="isContainerEmpty(item)"
                    (cdkDragStarted)="onDragStarted($event)"
                    (cdkDragMoved)="onDragMoved($event)"
                    (cdkDragEnded)="onDragEnded()"
                    [class.drag-over-container]="
                        item.value.item_type_value === 'item_container' && (isDragging$ | async)
                    "
                    [class.drag-hover-expanding]="
                        item.value.item_type_value === 'item_container' && isContainerHovered(i)
                    "
                >
                    <ng-container [ngSwitch]="item.value.item_type_value">
                        <app-materials-manager-text
                            *ngSwitchCase="'text_material'"
                            #materialItemComposer
                            [index]="i"
                            [disabled]="item.disabled"
                            [resource]="resource"
                            [opened]="opened"
                            [active]="active && !(isDragging$ | async) && !disableSorting.value"
                            [itemForm]="item | cast"
                            [isEditInBottomSheet]="isEditInBottomSheet"
                            (onDisableSorting)="disableSorting.next($event)"
                            (onDelete)="delete([i])"
                            (onCopy)="copy($event)"
                            (onTranslate)="translate({ language_id: $event.language_id, indices: $event.indices })"
                            (onRegenerate)="regenerate([i])"
                            (onDuplicate)="duplicate(i)"
                            (onCreateTestFromMaterial)="onCreateTestFromMaterial([i])"
                            (onSplitText)="splitText($event.blocksCount, $event.index)"
                            (onAddNewItem)="addNewItem($event)"
                            (onAddNewBlock)="onAddNewBlock($event)"
                            (onClearEditMode)="clearEditMode()"
                        >
                            <ng-container
                                [ngTemplateOutlet]="dragIcon"
                                [ngTemplateOutletContext]="{ index: i }"
                            ></ng-container>
                        </app-materials-manager-text>
                        <app-materials-manager-link
                            #materialItemComposer
                            *ngSwitchCase="'url_material'"
                            [index]="i"
                            [disabled]="item.disabled"
                            [resource]="resource"
                            [opened]="opened"
                            [itemForm]="item | cast"
                            [isEditInBottomSheet]="isEditInBottomSheet"
                            (onDisableSorting)="disableSorting.next($event)"
                            (onDelete)="delete([i])"
                            (onCopy)="copy($event)"
                            (onTranslate)="translate({ language_id: $event.language_id, indices: $event.indices })"
                            (onRegenerate)="regenerate([i])"
                            (onAddNewBlock)="onAddNewBlock($event)"
                            (onClearEditMode)="clearEditMode()"
                            (onCreateTestFromMaterial)="onCreateTestFromMaterial([i])"
                        >
                            <ng-container
                                [ngTemplateOutlet]="dragIcon"
                                [ngTemplateOutletContext]="{ index: i }"
                            ></ng-container>
                        </app-materials-manager-link>
                        <app-materials-manager-parent
                            #materialItemComposer
                            *ngSwitchCase="'item_container'"
                            [index]="i"
                            [disabled]="item.disabled"
                            [resource]="resource"
                            [opened]="opened"
                            [active]="active"
                            [itemForm]="item | cast"
                            [childrenIds]="resourceItemById(item.value.id)?.children_ids"
                            [isEditInBottomSheet]="isEditInBottomSheet"
                            (onDelete)="delete([i])"
                            (onLoading)="loading.emit($event)"
                            (onCopy)="copy($event)"
                            (onDuplicate)="duplicate(i)"
                            (onDisableSorting)="disableSorting.next($event)"
                            (onSplitText)="splitText($event.blocksCount, $event.index)"
                            (onPerformSubmit)="performResSubmit({ eager: 'items' })"
                            (onAddNewBlock)="onAddNewBlock($event)"
                            (onDownload)="download($event)"
                            (onClearEditMode)="clearEditMode()"
                            (onCreateTestFromMaterial)="onCreateTestFromMaterial([i])"
                        >
                            <ng-container
                                [ngTemplateOutlet]="dragIcon"
                                [ngTemplateOutletContext]="{ index: i }"
                            ></ng-container>
                        </app-materials-manager-parent>

                        <!-- <ng-container
                            *ngSwitchCase="'doc_material'"
                            [ngTemplateOutlet]="docMaterial"
                            [ngTemplateOutletContext]="{ i: i, item: item }"
                        ></ng-container> -->

                        <ng-container
                            *ngSwitchDefault
                            [ngTemplateOutlet]="docMaterial"
                            [ngTemplateOutletContext]="{ i: i, item: item }"
                        ></ng-container>
                    </ng-container>
                </div>
            </mat-accordion>
        </ng-container>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="relative-wrapper">
            <div
                *ngIf="!showPrompter.value && items.controls.length"
                [ngClass]="{ 'mt--20': items.controls.length <= 0 }"
                class="follow-up-btn"
            >
                <button class="follow-btn" mat-button (click)="onFollowUp()">
                    <mat-icon class="add-ai-btn">smart_toy</mat-icon>
                    <span i18n>Ask AI</span>
                </button>
                <button class="add-btn" mat-button (click)="addText()">
                    <mat-icon class="add-ai-btn">post_add</mat-icon>
                    <span i18n>Text</span>
                </button>
                <button
                    *ngIf="!isEditInBottomSheet"
                    matTooltip="Add image"
                    i18n-matTooltip
                    class="add-btn-icon"
                    mat-icon-button
                    (click)="addImg()"
                >
                    <mat-icon class="add-ai-btn">add_photo_alternate</mat-icon>
                </button>
                <button
                    *ngIf="!isEditInBottomSheet"
                    matTooltip="Add video"
                    i18n-matTooltip
                    class="add-btn-icon"
                    mat-icon-button
                    (click)="addVideo()"
                >
                    <mat-icon class="add-ai-btn">videocam</mat-icon>
                </button>
                <button
                    *ngIf="!isEditInBottomSheet"
                    matTooltip="Upload file"
                    i18n-matTooltip
                    class="add-btn-icon"
                    mat-icon-button
                    (click)="addFile()"
                >
                    <mat-icon class="add-ai-btn">cloud_upload</mat-icon>
                </button>
                <button matTooltip="Add link" i18n-matTooltip class="add-btn-icon" mat-icon-button (click)="addLink()">
                    <mat-icon class="add-ai-btn">add_link</mat-icon>
                </button>
                <ng-container *ngIf="canRecord$ | async">
                    <button
                        *ngIf="!isEditInBottomSheet"
                        matTooltip="Record a material"
                        i18n-matTooltip
                        fxHide.lt-md
                        class="add-btn-icon"
                        mat-icon-button
                        (click)="onRecordMaterial()"
                    >
                        <mat-icon class="add-ai-btn">radio_button_checked</mat-icon>
                    </button>
                </ng-container>
            </div>
            <div
                id="promptInput"
                fxLayout="column"
                fxFlex="0 1 100%"
                *ngIf="showPrompter.value"
                class="propmpter-wrapper"
            >
                <div class="ask-me" *ngIf="!prompt.value" i18n>
                    Write a prompter text to ask AI to assist you in this context
                </div>
                <mat-form-field fxFlex="0 1 100%">
                    <textarea
                        #input
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="15"
                        autofocus
                        matInput
                        type="text"
                        [formControl]="prompt"
                    >
                    </textarea>
                </mat-form-field>
                <div fxFlex="1 1 100%" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <button
                        [disabled]="!prompt.value"
                        class="create"
                        mat-button
                        i18n-matTooltip
                        matTooltip="Send a request to AI and wait for a reply"
                        (click)="addFUQ(); showPrompter.next(false)"
                    >
                        <mat-icon>smart_toy</mat-icon>
                        <span i18n>Create</span>
                    </button>
                    <button
                        class="prompter-cancel-btn"
                        type="button"
                        (click)="showPrompter.next(false)"
                        mat-button
                        matTooltip="Cancel"
                        i18n-matTooltip
                    >
                        <span>Cancel</span>
                    </button>
                </div>
            </div>

            <div *ngIf="items.controls.length && !showPrompter.value" class="counters tooltTipIcon">
                <button
                    (click)="$event.stopPropagation(); tooltip.toggle()"
                    (mouseenter)="tooltip.show()"
                    class="add-btn-icon"
                    #tooltip="matTooltip"
                    mat-icon-button
                    matTooltipClass="info-tooltip"
                    [matTooltip]="tooltipInfo"
                >
                    <mat-icon class="material-icons-outlined">info</mat-icon>
                </button>
            </div>
            <div *ngIf="showPrompter.value" class="counters prompt-input-on">
                <app-ai-model-selector (modelChange)="agent = $event"></app-ai-model-selector>
            </div>
        </div>
    </div>
</div>

<ng-template #docMaterial let-i="i" let-item="item">
    <app-materials-manager-file
        #materialItemComposer
        [index]="i"
        [disabled]="item.disabled"
        [opened]="opened"
        [resource]="resource"
        [itemForm]="item | cast"
        [isEditInBottomSheet]="isEditInBottomSheet"
        (onCreateNewItems)="addItemsFromChildren($event)"
        (onDisableSorting)="disableSorting.next($event)"
        (onDelete)="delete([i])"
        (onCopy)="copy($event)"
        (onTranslate)="translate({ language_id: $event.language_id, indices: $event.indices })"
        (onRegenerate)="regenerate([i])"
        (onDuplicate)="duplicate(i)"
        (onAddNewBlock)="onAddNewBlock($event)"
        (onClearEditMode)="clearEditMode()"
        (onCreateTestFromMaterial)="onCreateTestFromMaterial([i])"
    >
        <ng-container [ngTemplateOutlet]="dragIcon" [ngTemplateOutletContext]="{ index: i }"></ng-container>
    </app-materials-manager-file>
</ng-template>

<ng-template #dragIcon let-index="index">
    <button
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="orderMenu"
        #orderMenuTrigger="matMenuTrigger"
        matTooltip="Sorting / Drag and drop or click"
        i18n-matTooltip
        class="drag-btn"
        cdkDragHandle
        mat-icon-button
    >
        <mat-icon>reorder</mat-icon>
    </button>

    <mat-menu
        #orderMenu="matMenu"
        class="passing-menu-panel correct-alt-menu"
        [hasBackdrop]="true"
        [overlapTrigger]="false"
    >
        <div fxLayout="column" fxLayoutAlign="start start" class="sorting-prio-menu">
            <span i18n>Sorting priority</span>
            <mat-form-field class="passing-data">
                <mat-label i18n>Enter sorting priority</mat-label>
                <input
                    matInput
                    type="number"
                    min="0"
                    [formControl]="sortingPrio | cast"
                    (click)="$event.stopPropagation()"
                />
            </mat-form-field>
            <button
                color="primary"
                mat-button
                [disabled]="sortingPrio.value == null || sortingPrio.value == 0"
                (click)="orderMenuTrigger.closeMenu(); onSortPopup(index, sortingPrio.value - 1); sortingPrio.reset()"
                matMenuClose
            >
                <span i18n>Done</span>
            </button>
        </div>
    </mat-menu>
</ng-template>
<ng-template #contentTemplateToBeInParent>
    <mat-expansion-panel #trailerExpansionPanel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>video_library</mat-icon>
                <div i18n>Trailer</div>
                <mat-icon
                    class="icon-explain"
                    matTooltip="Video presentation of this course presenting it with a trailer"
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <mat-icon
                    *ngIf="trailerExpansionPanel.expanded && videoLinkControl?.videoMedia"
                    class="md-24 remove-trailer"
                    (click)="$event.stopPropagation(); videoLinkControl.clearMedia()"
                    >delete_outline</mat-icon
                >
                <span
                    matTooltip="Indicator of field change"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{ green: resourceForm.get('medias.trailer')?.dirty }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-video-link-control
                class="trailer-uploader-wrapper"
                [formControl]="resourceForm.get('medias.trailer') | cast"
                [uploaderBtnLabel]="'Upload trailer'"
                i18n-uploaderBtnLabel="@@uploadTrailer"
                [resourceId]="resource?.id"
                [canRemoveMedia]="false"
            ></app-video-link-control>
        </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>display_settings</mat-icon>
                <div i18n>Default name</div>
                <mat-icon class="icon-explain" matTooltip="Default name of the material to be displayed in the player"
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span matTooltip="Indicator of field change" i18n-matTooltip class="cell-indicator"></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <div fxLayoutGap="4px" fxLayout="row" class="w-50">
                <app-title-translation
                    type="title"
                    placeholder="Set default name"
                    i18n-placeholder
                    class="material-title-translation"
                    formControlName="labelTranslation"
                ></app-title-translation>
            </div>
        </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>fingerprint</mat-icon>
                <div i18n="@@SKU-ArticleNumber">SKU/ Article number</div>
                <mat-icon
                    class="icon-explain"
                    i18n-matTooltip
                    matTooltip="Article code is a unique field, autogenerated when empty."
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span matTooltip="Indicator of field change" i18n-matTooltip class="cell-indicator"></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-resource-article-code-form
                fxFlex="0 1 100%"
                formControlName="article_code"
                [resourceId]="resource?.id"
            ></app-resource-article-code-form>
        </ng-template>
    </mat-expansion-panel>
    <ng-container *ngIf="customFields$ | async as customFields">
        <ng-container *ngIf="customFields && customFields.length > 0">
            <app-resources-custom-fields
                [resource]="resource"
                [customFields]="customFields"
            ></app-resources-custom-fields>
        </ng-container>
    </ng-container>
</ng-template>
